export default "__VITE_ASSET__97xFvgg0__"